export default __webpack_public_path__ + "static/media/expl_14_EN.ab074a5e.png";